import React from "react";
import PropTypes from "prop-types";
import styles from "./Rating.css";

const Rating = ({ rating }) => {
  let starCount = 7;
  let rateCount = rating;
  const ratingGrid = [];

  while (starCount) {
    if (rateCount > 0) {
      ratingGrid.push(<span>&#9733;</span>);
      rateCount -= 1;
    } else {
      ratingGrid.push(<span>&#9734;</span>);
    }
    starCount -= 1;
  }

  return <div className={styles.Rating}>{ratingGrid}</div>;
};

Rating.propTypes = {
  rating: PropTypes.number.isRequired
};

export default Rating;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Skills/Skill/Rating/Rating.js